const CryptoJS = require('crypto-js');

const secretKey = 'MADI_DIGITALID_KEY1';

export const decryptDigitalId = (encryptedDigitalId) => {
    const decrypted = CryptoJS.AES.decrypt(atob(decodeURIComponent(encryptedDigitalId)), secretKey).toString(CryptoJS.enc.Utf8);
    return decrypted;
}

export const encryptData = (data) => {
    const encrypted = CryptoJS.AES.encrypt(data, secretKey).toString();
    return encodeURIComponent(btoa(encrypted)); 
};